import ApiHelpers from '@/data/dao/base/ApiHelpers';
import Client from '@/data/models/client';
import ClientBuildings from '@/data/models/client-buildings';

export default class ClientsDao {
  static getAll(): Promise<Array<Client>> {
    return ApiHelpers.get<Array<Client>>(`/admin/client`).then((data) => data.filter(it => it.name).map(it => Client.map(it)));
  }

  static create(client: Partial<Client>): Promise<Client> {
    return ApiHelpers.post<Client>(`/admin/client/create?withAuth=1`, client).then((data) => Client.map(data));
  }

  static update(id: string, client: Partial<Client>): Promise<Client> {
    return ApiHelpers.patch<Client>(`/admin/client/update/${id}`, client).then((data) => Client.map(data));
  }

  static getMe(): Promise<ClientBuildings> {
    return ApiHelpers.get<ClientBuildings>('/client/me').then((data) => ClientBuildings.map(data.client, data.buildingMeters));
  }

  static getClientBuildingMeters(clientUid: string): Promise<ClientBuildings>{
    return ApiHelpers.get<ClientBuildings>(`/admin/client/getClientStructureByUID/${clientUid}`).then((data) => ClientBuildings.map(data.client, data.buildingMeters));
  }

  static getClientById(clientUid: string): Promise<Client>{
    return ApiHelpers.get<Client>(`/admin/client/getById/${clientUid}`).then((data) => Client.map(data));
  }
}
